import { sendAjaxRequest } from "../ajax/ajax";
import { JSONResponse } from "./jsonResponse";
var DefaultResponseFactory = function (response) {
    return new JSONResponse(response);
};
function create(uri, request, responseFactory) {
    if (responseFactory === void 0) { responseFactory = DefaultResponseFactory; }
    return sendRequest("POST", uri, responseFactory, request);
}
function retrieve(uri, request, responseFactory) {
    if (request === void 0) { request = null; }
    if (responseFactory === void 0) { responseFactory = DefaultResponseFactory; }
    return sendRequest("GET", uri, responseFactory, request);
}
function retrieveCollection(uri, parameters, request, responseFactory) {
    if (parameters === void 0) { parameters = null; }
    if (request === void 0) { request = null; }
    if (responseFactory === void 0) { responseFactory = DefaultResponseFactory; }
    return sendRequest("GET", uri, responseFactory, request, parameters);
}
function update(uri, request, responseFactory) {
    if (responseFactory === void 0) { responseFactory = DefaultResponseFactory; }
    return sendRequest("PUT", uri, responseFactory, request);
}
function delete$(uri, request, responseFactory) {
    if (request === void 0) { request = null; }
    if (responseFactory === void 0) { responseFactory = DefaultResponseFactory; }
    return sendRequest("DELETE", uri, responseFactory, request);
}
function sendRequest(method, uri, responseFactory, endpointRequest, odataParameters) {
    if (endpointRequest === void 0) { endpointRequest = null; }
    if (odataParameters === void 0) { odataParameters = null; }
    var headers = endpointRequest == null ?
        {} :
        endpointRequest.headers;
    var body = endpointRequest == null ?
        "" :
        JSON.stringify(endpointRequest.body);
    var uriParts = uri.split("?");
    var uriOdataParameters = queryParametersFromODataParameters(odataParameters);
    if (uriOdataParameters != null) {
        uriParts.push(uriOdataParameters);
    }
    uri = uriParts.reduce(function (previousValue, currentValue, currentIndex) {
        return previousValue + (currentIndex == 1 ? "?" : currentIndex > 1 ? "&" : "") + currentValue;
    }, "");
    return sendAjaxRequest(method, uri, body, headers)
        .then(function (response) { return Promise.resolve(responseFactory(response)); }, function (error) { return Promise.reject(responseFactory(error)); });
}
function queryParametersFromODataParameters(odataParameters) {
    if (odataParameters === void 0) { odataParameters = null; }
    if (odataParameters == null) {
        return null;
    }
    var queryParameters = {};
    if (odataParameters.pagination != null) {
        var pageNumber = odataParameters.pagination.pageNumber;
        var pageSize = odataParameters.pagination.pageSize;
        queryParameters["$count"] = "true";
        queryParameters["$skip"] = "" + (pageNumber * pageSize);
        queryParameters["$top"] = "" + pageSize;
    }
    if (odataParameters.filter != null) {
        queryParameters["$filter"] = odataParameters.filter;
    }
    if (odataParameters.orderby != null) {
        queryParameters["$orderby"] = odataParameters.orderby;
    }
    var parameters = Object.keys(queryParameters);
    return parameters.length == 0 ?
        null :
        parameters
            .map(function (parameter) {
            return "".concat(encodeURIComponent(parameter), "=").concat(encodeURIComponent(queryParameters[parameter]));
        })
            .join("&");
}
export { create, delete$, retrieve, retrieveCollection, update, };
